"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _default = function _default() {
  return (0, _styledComponents.css)(["ul{list-style:disc;}ol{list-style:decimal;padding-left:1.5em;}li{margin-bottom:0.75em;padding-left:0.5em;position:relative;&:last-of-type{margin-bottom:0;}li:first-of-type{marign-top:0.75em;}}"]);
};

exports["default"] = _default;